import { cn } from '@/lib/utils'
import { HelpCircleIcon } from 'lucide-react'
import React from 'react'
import IconButton from './Button/IconButton'
import {
    Popover,
    PopoverAnchor,
    PopoverContent,
    PopoverTrigger,
} from './ui/popover'

interface IProps {
    children?: React.ReactNode
    size?: 'small' | 'medium' | 'large'
    Icon?: React.ReactElement
    /** className passado para o popover trigger */
    className?: string
}

export default function IconeAjuda({
    children,
    size,
    Icon,
    className,
}: IProps) {
    const sizeClass =
        size === 'small'
            ? '*:size-4'
            : size === 'large'
              ? '*:size-8'
              : '*:size-6'

    Icon ??= <HelpCircleIcon />

    return (
        <Popover>
            <PopoverTrigger asChild>
                <PopoverAnchor>
                    <IconButton
                        disableTouchRipple
                        className={cn(sizeClass, className)}
                    >
                        {Icon}
                    </IconButton>
                </PopoverAnchor>
            </PopoverTrigger>

            <PopoverContent className="text-left">{children}</PopoverContent>
        </Popover>
    )
}
